export default function SwitchComponent(props) {
  return<div>SwitchComponent</div>;
}
